import React from "react";
import { ApiLanguage } from "src/api/types";

const sizes = {
	default: "w-8",
};

interface LanguageIconProps {
	language: ApiLanguage;
	className?: string;
	size: keyof typeof sizes;
}

const LanguageIcon = ({ language, className, size }: LanguageIconProps) => {
	return (
		<img
			className={`${sizes[size]} rounded-sm ${className}`}
			src={language.icon}
			alt={language.code}
		/>
	);
};

LanguageIcon.defaultProps = {
	size: "default",
};

export default LanguageIcon;
